import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom'
import { AppGreen } from 'appconstants/AppColors'

export default function PermissionDenied() {
    const navigate = useNavigate()

    return (
        <Container component='main' maxWidth='xs'>
            <CssBaseline />
            <Box
                sx={{
                    marginTop: { xs: 10, sm: 15, md: 20 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    px: 3,
                }}
            >
                <Typography sx={{ fontSize: '64px', mb: 2 }}>🚫</Typography>
                <Typography
                    variant='h5'
                    sx={{ fontWeight: '700', mb: 1, color: '#333' }}
                >
                    Permission Denied
                </Typography>
                <Typography
                    sx={{ fontSize: '15px', color: '#666', mb: 4 }}
                >
                    You do not have permission to access this page. Please contact your administrator.
                </Typography>
                <Button
                    variant='contained'
                    onClick={() => navigate('/')}
                    sx={{
                        backgroundColor: AppGreen,
                        textTransform: 'none',
                        borderRadius: '24px',
                        px: 4,
                        color: '#fff',
                        py: 1.5,
                        fontSize: '15px',
                        fontWeight: '600',
                        '&:hover': { backgroundColor: AppGreen },
                    }}
                >
                    Go to Home
                </Button>
            </Box>
        </Container>
    )
}
